'use client'

import { useEffect } from 'react'
import { Button } from '@/components/ui/button'
import { siteConfig } from '@/lib/site.config'

export default function BlogPostError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('Article error:', error)
  }, [error])

  return (
    <div className="container mx-auto px-4 pt-44 pb-24 text-center">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-4xl font-heading text-white mb-6">Unable to Load Article</h1>
        <p className="text-lg text-white/90 mb-8">
          We&apos;re having trouble loading this article. It might have been moved or is temporarily unavailable.
        </p>

        {process.env.NODE_ENV === 'development' && error.message && (
          <div className="bg-white/5 rounded-lg p-4 text-left mb-8">
            <p className="text-sm font-mono text-white/80 break-all">
              {error.message}
            </p>
            {error.digest && (
              <p className="text-xs text-white/60 mt-2">
                Error ID: {error.digest}
              </p>
            )}
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button variant="cta" size="cta" onClick={reset}>
            Try Again
          </Button>
          <Button
            variant="cta"
            size="cta"
            onClick={() => window.location.href = siteConfig.blogPath}
          >
            Browse All Articles
          </Button>
          <Button
            variant="cta"
            size="cta"
            onClick={() => window.location.href = '/'}
          >
            Go Home
          </Button>
        </div>
      </div>
    </div>
  )
}
